<i18n>
{
  "en": {
    "productBoost": "Product boost",
    "saleRateIndexingRule": "Sale Rate Indexing Rules",
    "groupIndexingRule": "Demand Indexing Rules",
    "productIndexing": "Product Indexing",
    "productRecommendation": "Product Recommendations",
    "menuInitialRecommendation": "Menu Initial Recommendations",
    "menuBannerRecommendation": "Menu Banner Recommendations",
    "emptyManualConfigMessage": "No options available for manual settings"
  },
  "es": {
    "productBoost": "Product boost",
    "saleRateIndexingRule": "Relacionar tarifas",
    "groupIndexingRule": "Relacionar demandas",
    "productIndexing": "Relacionar productos",
    "productRecommendation": "Recomendar productos",
    "menuInitialRecommendation": "Recomendación inicial de Menú",
    "menuBannerRecommendation": "Recomendación de banner",
    "emptyManualConfigMessage":  "No hay ninguna opcion disponibles para las configuraciones manuales"
  }
}
</i18n>

<template>
  <div>
    <v-layout row wrap justify-space-around class="mb-8">
      <dynameat-management-button v-for="button in buttonList" :key="button.action"
                                  :title="button.title" action="management-button"
                                  :actionParams="button.routeInfo"
                                  :icon="button.icon" :show-badge="button.showBadge"
                                  :disabled="button.disabled" v-on="$listeners"
                                  class="btn danger dynameatManagementButton">
        <div v-if="button.multiIcons" class="d-flex">
          <v-icon v-for="(icon, index) in button.multiIcons || []" :key="`${index}-${button.title}`"
                  color="primary" large>{{ icon }}
          </v-icon>
        </div>
      </dynameat-management-button>
      <div v-if="buttonList.length === 0">
        <h2>{{$t('emptyManualConfigMessage')}}</h2>
      </div>
    </v-layout>
  </div>
</template>

<script>
import Vue from 'vue';
import DynameatManagementButton from '@dynameat/components/DynameatManagementButton';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import { PermissionController } from '@core/permissions';

@Component
@Components({ DynameatManagementButton })
export default class ManualConfigPanel extends Vue {
  get buttonList() {
    const buttons = [
      {
        disabled: false,
        routeInfo: { name: 'product-boost' },
        title: this.$t('productBoost'),
        icon: 'mdi-rocket-launch',
        showBadge: false
      },
      {
        disabled: false,
        routeInfo: { name: 'sale-rate-indexing-rule' },
        title: this.$t('saleRateIndexingRule'),
        icon: 'mdi-vector-link',
        showBadge: false
      },
      {
        disabled: false,
        routeInfo: { name: 'demand-indexing-rule' },
        title: this.$t('groupIndexingRule'),
        icon: 'mdi-link-variant',
        showBadge: false
      },
      {
        disabled: false,
        routeInfo: { name: 'product-indexing' },
        title: this.$t('productIndexing'),
        icon: '',
        showBadge: false,
        multiIcons: ['mdi-food-fork-drink', 'mdi-link-variant']
      },
      {
        disabled: false,
        routeInfo: { name: 'product-recommendation' },
        title: this.$t('productRecommendation'),
        icon: '',
        showBadge: false,
        multiIcons: ['mdi-food-fork-drink', 'mdi-arrow-right-thick', 'mdi-food-fork-drink']
      },
      {
        disabled: false,
        routeInfo: { name: 'menu-initial-recommendation' },
        title: this.$t('menuInitialRecommendation'),
        icon: '',
        showBadge: false,
        multiIcons: ['mdi-food-fork-drink', 'mdi-arrow-right-thick', 'mdi-book-open']
      },
      {
        disabled: false,
        routeInfo: { name: 'menu-banner-recommendation' },
        title: this.$t('menuBannerRecommendation'),
        icon: '',
        showBadge: false,
        multiIcons: ['mdi-food-fork-drink', 'mdi-arrow-right-thick', 'mdi-book-open']
      },
      {
        disabled: false,
        routeInfo: { name: 'linkTree' },
        title: this.$t('LinkTree'),
        icon: 'mdi-link-box-variant-outline',
        showBadge: false,
      },
      {
        disabled: false,
        routeInfo: { name: 'tableQr' },
        title: this.$t('TableQr'),
        icon: 'mdi-qrcode-edit',
        showBadge: false,
      }
    ];
    return buttons.filter((button) => PermissionController.getInstance().isAllowed(button.routeInfo.name));
  }
}
</script>
